export default {
  /*param_btn_search: "Search",
  param_btn_search_more: "More...",
  param_btn_search_more_hide: "Hide More",
  btn_save: "Save",
  btn_back: "Back To List",
  existed:"The record has already existed, please check!",


  copyClumn: "Copy",
  viewClumn: "View",
  editClumn:"Edit",
  deleteClumn:"Delete",
  selectClumn:"Select",

  pager_btn_first: "First Page",
  pager_btn_pre: "Previous Page",
  pager_btn_next: "Next Page",
  pager_btn_last: "Last Page",
  pager_pageNo: "Current Page",
  pager_pageCount: "Page Count",
  pager_pageSize: "Linage",
  pager_rowCount: "Row Count",
  pager_export_excel: "Export to excel",

  loginNameTitle:"Login Name",
  loginNameMsg:"Please input Login Name first!",
  passwordTitle:"Password",
  passwordMsg:"Please input Password first!",
  loginBtnTitle:"Sign in",
  uopMsg:"Incorrect username or password!",

  msgSysError: "System cannot complete, please try again later!",
  msg_system_error: "System error, please try again later!",
  msg_save_success: "Save successfully!",
  msg_del_success: "Delete successfully!"
  */
}
